// Client mirror of the server normalizeRole
// (middleware/netlify-db-service/src/auth/access-control.js). S5 / ADR-004.
//
// `installer` is a legacy alias for `dealer`; any unrecognised role resolves to
// `customer` — IDENTICAL to the server (full parity is what keeps CHR-009 green).
// We ADDITIONALLY console.warn on an unrecognised, non-empty role — a log-only side
// effect that does NOT change the resolved value (RISK-ROLE-DOWNGRADE surfacing).
//
// Route every UI role-literal check through normalizeRole / roleIsOneOf so an
// installer-aliased account behaves identically to a dealer from every entry point,
// ending the App.vue / router / AdminConsole disagreement (H3).

export const CANONICAL_ROLES = ['customer', 'dealer', 'supplier', 'operations', 'admin', 'superadmin'];
export const LEGACY_ROLE_ALIASES = Object.freeze({ installer: 'dealer' });
export const ASSIGNABLE_ROLES = [...CANONICAL_ROLES]; // matches server ASSIGNABLE_ROLES (no `installer`)

export function normalizeRole(role) {
  if (LEGACY_ROLE_ALIASES[role]) return LEGACY_ROLE_ALIASES[role];
  if (CANONICAL_ROLES.includes(role)) return role;
  if (role != null && role !== '') console.warn(`[roles] unrecognised role "${role}" -> customer`);
  return 'customer';
}

/** Membership test with server-parity normalisation on BOTH sides (installer === dealer). */
export function roleIsOneOf(role, allowed) {
  const normalized = normalizeRole(role);
  return allowed.some((a) => normalizeRole(a) === normalized);
}
